var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overlap-spacing" }, [
    _c(
      "div",
      {
        class: [
          "level-card",
          {
            active: _vm.isActive,
            complete: _vm.isComplete,
            recommended: _vm.isRecommended,
            "placed-out": _vm.isPlacedOut
          }
        ],
        on: {
          click: function($event) {
            return _vm.$emit("click-card", _vm.level)
          }
        }
      },
      [
        _c("div", { staticClass: "flex-center header" }, [
          _c(
            "div",
            { staticClass: "stats" },
            [
              _c("BadgeLabel", {
                staticClass: "stat",
                attrs: {
                  text: "Level " + _vm.level.number,
                  color: _vm.badgeColor
                }
              }),
              _vm._v(" "),
              _vm.isRecommended
                ? _c("Tag", {
                    staticClass: "level-tag",
                    attrs: {
                      text: "Recommended",
                      color: "#F2BD57",
                      "text-color": "#000000"
                    }
                  })
                : _vm.isComplete
                ? _c("Tag", {
                    staticClass: "level-tag",
                    attrs: {
                      text: "Completed",
                      color: "#E8F5F2",
                      "text-color": "#179E7E"
                    }
                  })
                : _vm.isPlacedOut
                ? _c("Tag", {
                    staticClass: "level-tag",
                    attrs: {
                      text: "Placed Out",
                      color: "#E8F5F2",
                      "text-color": "#179E7E"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-center info" }, [
          _c("h2", { staticClass: "title" }, [_vm._v(_vm._s(_vm.level.title))]),
          _vm._v(" "),
          _c("p", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.level.intro_text))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-center footer" },
          [
            !_vm.isComplete
              ? _c("ProgressBar", {
                  staticClass: "progress-bar",
                  attrs: { "percent-complete": _vm.level.percent_complete }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "Button",
              {
                staticClass: "cta",
                attrs: {
                  primary: !_vm.isComplete && !_vm.isPlacedOut,
                  loading: _vm.loading,
                  disabled: _vm.loading,
                  "aria-label": _vm.ctaAriaLabel
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.$emit("click-cta", _vm.level)
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.ctaCopy) + "\n      ")]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }